import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import createAppReducer, { createInitialState } from './modules'

export const store = createStore(createAppReducer(), createInitialState(), compose(applyMiddleware(thunk)))
